import {TvShopEntertainmentPack} from '../../../model/tv-shop-entertainment-pack';
import {LanguageService} from '../../../services/language/language.service';
import {Injectable} from '@angular/core';

@Injectable()
export class EntertainmentPackUtils {

  constructor(private languageService: LanguageService) {}

  public sortDtvCatalogOnWeight(packs: TvShopEntertainmentPack[]) {
    if (this.languageService.getCurrentLanguage() === 'fr') {
      packs.sort((pack1, pack2) => pack2.omapiCharacteristics && pack1.omapiCharacteristics ? pack2.omapiCharacteristics.weightfr - pack1.omapiCharacteristics.weightfr : -1);
    } else {
      packs.sort((pack1, pack2) => pack2.omapiCharacteristics && pack1.omapiCharacteristics ? pack2.omapiCharacteristics.weightnl - pack1.omapiCharacteristics.weightnl : -1);
    }
  }
}
